var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.viewContainer
  }, [_vm.initialLoading ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : !_vm.successfully ? _c('div', [_c('div', {
    staticClass: "mt-40"
  }, [_c('BaseTitle', {
    class: _vm.$style.title
  }, [_vm._v("Security")])], 1), _c('InfoBlock', {
    staticClass: "mb-4"
  }, [_vm._v(" Current Password is required to Change Password or Change Security Question/Answer ")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('form', [_c('BaseFormGroup', {
    attrs: {
      "label": _vm.labels.password
    }
  }, [_c('BaseInputPassword', {
    attrs: {
      "name": "password",
      "changed": _vm.password !== '',
      "error": _vm.isEmptyPassword ? 'The current password is required.' : _vm.isWrongPassword ? 'The current password is incorrect. Try again.' : '',
      "placeholder": _vm.placeholders.password
    },
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr', {
    class: _vm.$style.hr
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('form', {
    staticClass: "px-0",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitChangePasswordForm.apply(null, arguments);
      }
    }
  }, [_c('h3', {
    class: _vm.$style.h3
  }, [_vm._v("Change my Password")]), _c('BaseFormGroup', {
    staticClass: "mb-40",
    attrs: {
      "label": _vm.labels.newPassword
    }
  }, [_c('BaseInputPassword', {
    attrs: {
      "changed": _vm.newPassword !== '',
      "name": "newPassword",
      "placeholder": _vm.placeholders.newPassword
    },
    model: {
      value: _vm.newPassword,
      callback: function callback($$v) {
        _vm.newPassword = $$v;
      },
      expression: "newPassword"
    }
  })], 1), _c('BaseFormGroup', {
    staticClass: "mb-40",
    attrs: {
      "label": _vm.labels.confirmNewPassword
    }
  }, [_c('BaseInputPassword', {
    attrs: {
      "name": "confirmNewPassword",
      "changed": _vm.confirmNewPassword !== '',
      "error": _vm.isWrongConfirmNewPassword ? 'The passwords don’t match.' : '',
      "placeholder": _vm.placeholders.confirmNewPassword
    },
    model: {
      value: _vm.confirmNewPassword,
      callback: function callback($$v) {
        _vm.confirmNewPassword = $$v;
      },
      expression: "confirmNewPassword"
    }
  })], 1), _c('div', {
    class: _vm.$style.divButton
  }, [_c('BaseButton', {
    class: _vm.$style.button,
    attrs: {
      "disabled": !_vm.canPressChangePasswordButton,
      "type": "submit"
    }
  }, [_vm.loadingChangePassword ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Change Password")])], 1)], 1)], 1)]), _c('div', {
    staticClass: "col-md-12",
    class: _vm.$style.showMobile
  }, [_c('hr', {
    class: _vm.$style.hr
  })]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('form', {
    staticClass: "px-0",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitChangeSecurityQuestionForm.apply(null, arguments);
      }
    }
  }, [_c('h3', {
    class: _vm.$style.h3
  }, [_vm._v("Change my Security Question")]), _c('BaseFormGroup', {
    staticClass: "mb-40",
    attrs: {
      "label": _vm.labels.recoveryQuestion
    }
  }, [_c('BaseSelect', {
    attrs: {
      "name": "recoveryQuestion",
      "empty-text": "-- Select a Security Question --",
      "options": _vm.recoveryQuestions,
      "changed": _vm.recoveryQuestion !== _vm.originalRecoveryQuestion,
      "option-text": "questionText",
      "option-value": "questionText"
    },
    model: {
      value: _vm.recoveryQuestion,
      callback: function callback($$v) {
        _vm.recoveryQuestion = $$v;
      },
      expression: "recoveryQuestion"
    }
  })], 1), _c('BaseFormGroup', {
    staticClass: "mb-40",
    attrs: {
      "label": _vm.labels.recoveryAnswer
    }
  }, [_c('BaseInputText', {
    attrs: {
      "autocomplete": "off",
      "name": "recoveryAnswer",
      "changed": _vm.recoveryAnswer !== '',
      "error": _vm.isWrongRecoveryAnswer ? 'The recovery answer must be at least 4 characters.' : '',
      "placeholder": _vm.placeholders.recoveryAnswer
    },
    model: {
      value: _vm.recoveryAnswer,
      callback: function callback($$v) {
        _vm.recoveryAnswer = $$v;
      },
      expression: "recoveryAnswer"
    }
  })], 1), _c('div', {
    class: _vm.$style.divButton
  }, [_c('BaseButton', {
    class: _vm.$style.button,
    attrs: {
      "disabled": !_vm.canPressChangeSecurityQuestionButton,
      "type": "submit"
    }
  }, [_vm.loadingChangeSecurityQuestion ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Change Security Question/Answer")])], 1)], 1)], 1)])]), _vm.showNotificationsSection ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('hr', {
    class: _vm.$style.hr
  })])]), _c('div', {
    staticClass: "mt-40"
  }, [_c('BaseTitle', {
    class: _vm.$style.title
  }, [_vm._v("Notifications")])], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    staticClass: "px-0",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitSaveNotificationsForm.apply(null, arguments);
      }
    }
  }, [_c('BaseCheckbox', {
    staticClass: "mt-30 mb-40",
    attrs: {
      "label": "Deal-level referral email notifications",
      "input-value": '1'
    },
    model: {
      value: _vm.emailNotificationReferral,
      callback: function callback($$v) {
        _vm.emailNotificationReferral = $$v;
      },
      expression: "emailNotificationReferral"
    }
  }), _c('div', {
    class: _vm.$style.divButton
  }, [_c('BaseButton', {
    class: _vm.$style.button,
    attrs: {
      "disabled": !_vm.canPressSaveNotificationsButton,
      "type": "submit"
    }
  }, [_vm.loadingSaveNotifications ? _c('BaseIcon', {
    attrs: {
      "name": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Save Preferences")])], 1)], 1)], 1)])])]) : _vm._e()], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }